var map = {
	"./build-a-blockchain-from-scratch-in-go.jpg": 9184,
	"./building-ethereum-dapps-decentralized-applications-on-the-ethereum-blockchain.jpg": 7993,
	"./coding-democracy.jpg": 7060,
	"./ethereum-blockchains-digital-assets-smart-contracts-decentralized-autonomous-organizations.jpg": 2345,
	"./ethereum-for-web-developers.jpg": 264,
	"./foundry-book.jpg": 9701,
	"./hands-on-smart-contract-development-with-solidity-and-ethereum-from-fundamentals-to-deployment.jpg": 6858,
	"./how-to-defi-advanced.jpg": 9904,
	"./how-to-defi.jpg": 7071,
	"./lexon-digital-contracts.jpg": 3945,
	"./life-after-google.jpg": 2385,
	"./mastering-ethereum.jpg": 8714,
	"./out-of-the-ether.jpg": 845,
	"./proof-of-stake.jpg": 4959,
	"./solidity-design-patterns.jpg": 1240,
	"./solidity-starters.jpg": 9616,
	"./the-cryptopians.jpg": 8204,
	"./the-infinite-machine.jpg": 1928,
	"./the-network-state.jpg": 3048,
	"./token-economy.jpg": 4052,
	"./upgrading-ethereum.jpg": 7447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7201;